import axios from '@/lib/v2/axios';

export const getResidents = async (communityId?: string, params?: { 
  include?: string; 
  sort?: string; 
  page?: number; 
  per_page?: number; 
  all?: boolean;
}) => {
  if (!communityId) {
    return { residents: [] };
  }

  const { data } = await axios.get(`/api/v2/communities/${communityId}/residents`, { params });
  if (Array.isArray(data)) {
    return { residents: data };
  }
  if (Array.isArray(data?.residents)) {
    return data;
  }
  if (Array.isArray(data?.data)) {
    return { ...data, residents: data.data };
  }
  return { ...data, residents: [] };
};

export interface GetResidentResponse {
  resident: any;
  custom_fields?: Array<{
    id: string;
    community_id: string;
    name: string;
    key: string;
    visible_to_member: boolean;
    editable_by_member: boolean;
    sort_order: number;
  }>;
  custom_field_values?: Record<string, string>;
}

export const getResident = async (
  communityId?: string,
  residentId?: string,
  params?: { include?: string; sort?: string }
): Promise<GetResidentResponse | null> => {
  if (!communityId || !residentId) {
    return null;
  }

  try {
    const { data } = await axios.get<GetResidentResponse>(
      `/api/v2/communities/${communityId}/residents/${residentId}`,
      { params }
    );
    return data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      throw new Error('User not found');
    }
    throw error;
  }
};

/** Current user's resident data for a community (custom fields visible to member). For settings/details. */
export const getResidentMe = async (
  communityId: string
): Promise<GetResidentResponse | null> => {
  if (!communityId) {
    return null;
  }
  try {
    const { data } = await axios.get<GetResidentResponse>(
      `/api/v2/communities/${communityId}/residents/me`
    );
    return data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const updateResidentCustomFieldValues = async (
  communityId: string,
  residentId: string,
  values: Record<string, string | null>
): Promise<{ message: string; data: Record<string, string> }> => {
  const { data } = await axios.patch(
    `/api/v2/communities/${communityId}/residents/${residentId}/custom-field-values`,
    { values }
  );
  return data;
};

export const createResident = async (communityId?: string, resident?: any) => {
  if (!communityId) {
    return null;
  }

  const { data } = await axios.post(`/api/v2/communities/${communityId}/residents`, resident);
  return data;
};

/** Archive a resident (soft delete). Data is preserved but they no longer appear in lists. */
export const archiveResident = async (
  communityId: string,
  residentId: string
): Promise<{ success: boolean; message: string }> => {
  const { data } = await axios.post(
    `/api/v2/communities/${communityId}/residents/${residentId}/archive`
  );
  return data;
};
